/*
 * bpmbuild-uat-ds.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildUatDsappspotcom) {
      root.BpmbuildUatDsappspotcom = {};
    }
    root.BpmbuildUatDsappspotcom.StripeSubscriptionItemMetadataBean = factory(root.BpmbuildUatDsappspotcom.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';

  /**
   * The StripeSubscriptionItemMetadataBean model module.
   * @module model/StripeSubscriptionItemMetadataBean
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>StripeSubscriptionItemMetadataBean</code>.
   * @alias module:model/StripeSubscriptionItemMetadataBean
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>StripeSubscriptionItemMetadataBean</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StripeSubscriptionItemMetadataBean} obj Optional instance to populate.
   * @return {module:model/StripeSubscriptionItemMetadataBean} The populated <code>StripeSubscriptionItemMetadataBean</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('data'))
        obj.data = ApiClient.convertToType(data['data'], 'String');
    }
    return obj;
  }

  /**
   * @member {String} data
   */
  exports.prototype.data = undefined;

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsUatds/src/model/StripeSubscriptionItemMetadataBean.js